import Shared from 'emun.cart/cart.controller'
import resolve from 'ioc/resolve'
import templateUrl from 'emun.cart/import/cart-file-import.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import $session from 'servicestack/session'
import modals from 'webmodals/modals'

class CartFileImportController extends Shared{
    constructor ($cart, $rootScope, $state, createAutoQuery, createServiceBus, modals) {
        super($cart)
        let $stateParams = resolve('$stateParams');
        if ($stateParams.cartId) $cart.load($stateParams.cartId);
        this.retailerQuery = new AutoQuery({
            url: 'QueryRetailers.json?Id=' + $session.retailerId,
            autoLoad: true,
            onLoaded: args => {
                this.$cart.purchaser = args.first;
                this.$cart.billingLocation = args.first;
            }
        });
        this.paymentMethodsQuery = new AutoQuery({
            url: 'QueryRetailerPaymentMethods.json?RetailerId=' + $session.retailerId,
            autoLoad: true,
            onLoaded: args => this.$cart.paymentMethod = args.first
        });
        $cart.createCart({
            cartName: "TEMP",
            type: '',
            businessModel: $session.businessModel,
            purchaser: {
                id: $session.retailerId || $session.userAuthId
            }
        }).then(function(cart) {
            $cart.load(cart.cartId);
        });
        this.shipCodes = ['UPS_GR','UPS_GC','UPS_NDA','UPS_NDAR','NDASaver','NDASaverR','UPS_2DA','UPS_2DAR','FED_SO','FED_PO','FED_2DAC','FED_2DAR','FED_GR','FED_GC','FED_GH','INT_FED_ECO'];
        this.modals = modals;
    }

    cleanCsvValue = function(value) {
        return value
            .replace(/^\s*|\s*$/g,"") // remove leading & trailing space
			.replace(/^"|"$/g,"") // remove " on the beginning and end
			.replace(/""/g,'"'); // replace "" with "
    }

	csvToJSON = function(content) {
        let $ctrl = this;
		var lines=content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
		var result = [];
		var start = 0;
		var columnCount = lines[0].split(content.separator).length;

		var headers = [];
		if (content.header) {
			headers=lines[0].split(content.separator);
			start = 1;
		}

		for (var i=start; i<lines.length; i++) {
			var obj = {};
			var currentline=lines[i].split(new RegExp(content.separator+'(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
			if ( currentline.length === columnCount ) {
				if (content.header) {
					for (var j=0; j<headers.length; j++) {
						obj[headers[j]] = $ctrl.cleanCsvValue(currentline[j]);
					}
				} else {
					for (var k=0; k<currentline.length; k++) {
						obj[k] = $ctrl.cleanCsvValue(currentline[k]);
					}
				}
				result.push(obj);
			}
		}
		return result;
	}

	processFile = function(file) {
        let $ctrl = this;
        $ctrl.finished = false;
        $ctrl.filename = file.name;
        $ctrl.cleanFile = true;
        $ctrl.errors = [];
        $ctrl.errors.errorCodes = [];
        var reader = new FileReader();
        reader.onload = function(ev) {
            var content = {
                csv: ev.target.result.replace(/\r\n|\r/g, '\n'),
                header: true,
                separator: ','
            };
            $ctrl.content = content.csv;
            $ctrl.result = $ctrl.csvToJSON(content);
            var lastOrderID = "";
            $ctrl.orderCount = 0;
            $ctrl.itemCount = 0;
            angular.forEach($ctrl.result, function(r) {
			        if (r.OrderID != lastOrderID) {
			            $ctrl.orderCount += 1;
			            lastOrderID = r.OrderID;
			        }
			        $ctrl.itemCount += 1;
			        var query = new AutoQuery({
			            url: 'QueryProducts.json?Take=1&Id=' + r.Item,
			            autoLoad: true,
			            onLoaded: args => {
			                if (args.first) {
			                    r.valid = true;
			                    if (r["LnNo"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "LnNo",
			                            message: "LnNo is required"
			                        });
			                    }
			                    if (r["OrderID"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "OrderID",
			                            message: "OrderID is required"
			                        });
			                    }
			                    if (r["Quantity"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Quantity",
			                            message: "Quantity is required"
			                        });
			                    } else {
			                        if (r.Quantity.length > 4) {
			                            r.valid = false;
			                            $ctrl.cleanFile = false;
			                            $ctrl.errors.push({
			                                errorCode: "-1",
			                                fieldName: "Quantity",
			                                message: "Quantity greater than 4 digits"
			                            });
			                        }
			                    }
			                    if (r["Ship Name"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship Name",
			                            message: "Ship Name is required"
			                        });
			                    }
			                    if (r["Ship Addr1"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship Addr1",
			                            message: "Ship Addr1 is required"
			                        });
			                    }
			                    if (r["Ship City"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship City",
			                            message: "Ship City is required"
			                        });
			                    }
			                    if (r["Ship State"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship State",
			                            message: "Ship State is required"
			                        });
			                    }
			                    if (r["Ship Zip"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship Zip",
			                            message: "Ship Zip is required"
			                        });
			                    }
			                    if (r["Ship Country"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship Country",
			                            message: "Ship Country is required"
			                        });
			                    }
			                    if (r["Ship Method"] == "") {
			                        r.valid = false;
			                        $ctrl.cleanFile = false;
			                        $ctrl.errors.push({
			                            errorCode: "-1",
			                            fieldName: "Ship Method",
			                            message: "Ship Method is required"
			                        });
			                    } else {
			                        if ($ctrl.shipCodes.indexOf(r["Ship Method"].toUpperCase()) == -1) {
			                            r.valid = false;
			                            $ctrl.cleanFile = false;
			                            $ctrl.errors.push({
			                                errorCode: "-1",
			                                fieldName: "Ship Method",
			                                message: "Invalid Ship Method"
			                            });
			                        }
			                    }
			                    if (r["URL/FileName"]) {
			                        if (r["URL/FileName"].indexOf("http://") == -1) {
			                            if (r["URL/FileName"].indexOf("https://") == -1) {
			                                r.valid = false;
			                                $ctrl.cleanFile = false;
			                                $ctrl.errors.push({
			                                    errorCode: "-1",
			                                    fieldName: "URL/FileName",
			                                    message: "URL/FileName must begin with http:// or https://"
			                                });
			                            }
			                        }
			                    }
                            } else {
			                    $ctrl.errors.push("Item " + r.Item + " is not a valid item");
			                    r.valid = false;
			                    $ctrl.cleanFile = false;
			                }
			            }
			        });
            });
            if ($ctrl.errors) {
                $ctrl.validationErrors = [];
                $ctrl.validationErrors.push($ctrl.errors);
            }
        };
        reader.readAsText(file);
    }

    submitOrders = function() {
        let $ctrl = this;
        $ctrl.finished = false;
        var request = {
            items: []
        };
        angular.forEach($ctrl.result, function(r) {
            request.items.push({
                OrderId: r.OrderID,
                Item: r.Item,
                ItemDesc: r.ItemDesc,
                UPC: r["UPC/SKU"],
                Filename: r["URL/FileName"],
                Quantity: r.Quantity,
                ShipName: r["Ship Name"],
                ShipAddress1: r["Ship Addr1"],
                ShipAddress2: r["Ship Addr2"],
                ShipCity: r["Ship City"],
                ShipState: r["Ship State"],
                ShipZip: r["Ship Zip"],
                ShipCountry: r["Ship Country"],
                ShipMethod: r["Ship Method"],
                ShipAccount: r["Ship 3rd Party Account#"]
            })
        });
        return $ctrl.$cart.bus.send('ImportCartItems.json', request).then(function (response) {
            $ctrl.finished = true;
            $ctrl.result = null;
            $ctrl.$cart.removeCart($ctrl.$cart.id);
        });
            
    }
}

let CartFileImport = {
    controller: CartFileImportController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};

export default CartFileImport;